import React from 'react';
import { Grid, Typography } from '@mui/material';

const ReportGroup = ({ title, totalReportGroups, children }) => {
  return (
    <Grid key={title} container direction="column" spacing={2} sx={{ mb: 2 }}>
      {/* No need to display the title if there is only one report group */}
      {totalReportGroups > 1 && (
        <Grid>
          <Typography variant="pageSection">{title}</Typography>
        </Grid>
      )}
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {children}
      </Grid>
    </Grid>
  );
};

export default ReportGroup;
